export default {"src":"/_next/static/media/study-icon.119413f9.svg","height":14,"width":14};